function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { SelectEl } from "common/components/select";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonBarEl } from "common/components/button-bar";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { InviteUsersModalEl } from "common/widgets/invite-users-modal";
import { ToastPortalEl } from "common/components/toast-portal";
import { LoadEntityModalEl } from "common/widgets/load-entity-modal";
import { CreateProjectModalEl } from "common/widgets/create-project-modal";
import { OrganizationIconEl } from "common/widgets/organization-icon";
import { ChangelogModalEl } from "common/widgets/changelog-modal";
import { ProjectFeatureFlag, ReportName } from "common/report/constants";
import { ButtonBarTheme } from "common/components/button-bar/types";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { events, track } from "common/report/util/settings-tracking";
import { numberInUSD } from "common/util";
import { OnboardingChecklistEl } from "common/widgets/onboarding-checklist";
import { BrowseEntityTypeFilter } from "common/report/util/search";
import { getReportName } from "common/report/util";
import { NavCategoryType } from "./constants";
import { SupportWidgetEl } from "./support-widget";
import { ReportsMenuEl } from "./reports-menu";
import { GlobalSearchEl } from "./global-search";
export function template() {
  var _this$helpers$getStar, _this = this, _this$getCurrentUser, _this$state$productUp, _this$getCurrentUser2;
  if (this.isDownloadMode()) {
    return /* @__PURE__ */ jsx("div", null);
  }
  const {
    categories,
    createProjectError,
    currentReportName,
    errorAlertMsg,
    inviteModalOrgs,
    isOpen,
    isSupportWidgetMaximized,
    projectId,
    projectMenuWorkspaces,
    searchedText,
    selectedCategory,
    showSupportWidget,
    showChangelogModal
  } = this.state;
  const shouldDisplayNavigationOptions = this.helpers.shouldDisplayNavigationOptions();
  const currentWorkspace = this.helpers.getCurrentWorkspace();
  const workspaceId = this.currentWorkspaceId;
  const searchModalDisplayContext = this.helpers.getSearchModalDisplayContext();
  const dataManagementMenu = /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-data-management", class: {
    "mp-chrome-header-trigger-container-active": isOpen.dataManagementMenu
  }, on: {
    click: () => this.helpers.selectMenuChanged("dataManagement", !isOpen.dataManagementMenu)
  } }, isOpen.dataManagementMenu ? /* @__PURE__ */ jsx(ReportsMenuEl, { attrs: {
    "current-report-name": currentReportName,
    "project-id": projectId,
    order: JSON.stringify(Object.keys(this.helpers.getNavReportsFromCategory(NavCategoryType.DataManagement))),
    open: true,
    "workspace-id": workspaceId
  }, params: {
    reports: this.helpers.getNavReportsFromCategory(NavCategoryType.DataManagement)
  }, on: {
    closemenu: () => this.helpers.handleCategoryCloseMenu("dataManagementMenu")
  } }) : null, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-trigger-container-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "brand-data-management"
  } })), this.helpers.allMenusClosed() ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom
  } }, this.t("nav-header.data-management")) : null);
  const helpMenu = /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-help", class: {
    "mp-chrome-header-trigger-container-active": isOpen.helpMenu
  } }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
    elref: "helpMenu",
    "menu-width": 256,
    "disable-search": true,
    "icon-only": true,
    "menu-height": 0,
    "align-all-text": true
  }, props: {
    sectionsFn: () => this.helpers.getHelpMenuSections()
  }, on: {
    change: this.helpers.helpMenuItemSelected,
    menuChange: (ev) => this.helpers.selectMenuChanged("help", ev.detail.isOpen)
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-trigger-container-icon", class: {
    "mp-chrome-header-trigger-container-notif": this.helpers.shouldShowHelpMenuNotif()
  }, attrs: {
    slot: "trigger"
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "brand-help"
  } }))), this.helpers.allMenusClosed() ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom
  } }, this.t("nav-header.help")) : null, this.state.showOnboardingChecklistHelpTooltip && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom,
    "always-show": true
  } }, "You can reopen Onboarding Guide from the Help tab"));
  const applicationMenu = /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-trigger-container", class: {
    "mp-chrome-header-trigger-container-active": isOpen.applicationsMenu
  } }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
    elref: "applicationsMenu",
    "search-threshold": 10,
    "menu-width": 300,
    "menu-height": 400
  }, props: {
    sectionsFn: () => this.helpers.getApplicationsMenuSections()
  }, on: {
    change: this.helpers.menuItemSelected,
    menuChange: (ev) => this.helpers.selectMenuChanged("applications", ev.detail.isOpen)
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-trigger-container-icon", attrs: {
    slot: "trigger"
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "brand-applications"
  } }))), this.helpers.allMenusClosed() ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom
  } }, this.t("nav-header.applications")) : null);
  const settingsMenu = /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-trigger-container", class: {
    "mp-chrome-header-trigger-container-active": isOpen.setupMenu
  } }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
    elref: "settingsMenu",
    "empty-message": "Loading\u2026",
    "disable-search": true,
    "menu-width": 280,
    // adjusted to show `log out` button w/o scrolling
    "menu-height": 570
  }, class: {
    "mp-chrome-header-trigger-container-notif": true
  }, props: {
    sectionsFn: () => this.helpers.getSettingsMenuSections().filter(Boolean)
  }, on: {
    click: this.helpers.warmUsageAnalyticsData,
    change: this.helpers.menuItemSelected,
    menuChange: (ev) => this.helpers.selectMenuChanged("setup", ev.detail.isOpen)
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-trigger-container-icon", attrs: {
    slot: "trigger"
  }, class: {
    "mp-chrome-header-trigger-container-notif": this.helpers.shouldShowSettingsMenuNotif()
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "brand-settings"
  } }))), this.helpers.shouldShowSettingsMenuNotif() ? /* @__PURE__ */ jsx(TooltipEl, { sel: ".startup-credit-tooltip", attrs: {
    "always-show": true,
    placement: Placement.Bottom,
    "max-width": "400px",
    "break-word": true
  }, style: {
    display: this.helpers.allMenusClosed() ? "" : "none"
  } }, track(events.viewedStartupCreditPromoTooltip), /* @__PURE__ */ jsx("div", { sel: ".tooltip-text-container" }, /* @__PURE__ */ jsx("div", { sel: ".tooltip-close-icon-container" }, /* @__PURE__ */ jsx(SvgIconEl, { sel: ".tooltip-close", attrs: {
    icon: "x"
  }, on: {
    click: this.setViewedStartupCreditPromo
  } })), /* @__PURE__ */ jsx("div", { sel: ".tooltip-title", style: {
    "font-size": "18px",
    "line-height": "24px"
  } }, "Upgrade your plan from Free to Growth with your", " ", numberInUSD(this.helpers.getStartupCreditBalances().remainingBalance), " of credits!"), /* @__PURE__ */ jsx("br", null), /* @__PURE__ */ jsx("div", { sel: ".tooltip-body" }, "You have used ", /* @__PURE__ */ jsx("strong", null, numberInUSD(this.helpers.getStartupCreditBalances().creditUsageAmount)), " of", " ", /* @__PURE__ */ jsx("strong", null, numberInUSD(this.helpers.getStartupCreditBalances().initialValue)), " ", "of your Mixpanel Startup Credits. You have until", " ", /* @__PURE__ */ jsx("strong", null, (_this$helpers$getStar = this.helpers.getStartupCreditInfo()) === null || _this$helpers$getStar === void 0 ? void 0 : _this$helpers$getStar.endDate), " to redeem your credits."), /* @__PURE__ */ jsx("br", null), /* @__PURE__ */ jsx("div", { sel: ".upgrade-to-redeem-credits-btn-container" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Primary
  }, on: {
    click: (ev) => {
      this.setViewedStartupCreditPromo();
      this.helpers.navigate("/pricing/plan-builder", ev, {
        fromAnchorlink: false
      });
      track(events.clickStartupPromoLink, {
        "Navigated From": "Tooltip Button"
      });
    }
  } }, "Upgrade to redeem credits")))) : this.helpers.allMenusClosed() ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom
  } }, this.t("nav-header.settings")) : null);
  const projectMenu = /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-project-menu-container" }, ((_this$helpers$getCurr) => {
    const displayWorkspaceSelection = this.helpers.areWorkspacesActivated();
    const projectsLength = this.helpers.getProjectsForMenu().length;
    return /* @__PURE__ */ jsx(SelectEl, { attrs: {
      elref: "projectsMenu",
      "search-placeholder": displayWorkspaceSelection ? this.t("nav-header.search-data-views") : this.t("nav-header.search-projects"),
      "menu-width": 300,
      "menu-height": 400,
      "back-button": displayWorkspaceSelection,
      "header-title": displayWorkspaceSelection ? "".concat(this.t("nav-header.data-views"), " (").concat(projectMenuWorkspaces.length, ")") : "".concat(this.t("nav-header.projects"), " (").concat(projectsLength, ")")
    }, props: {
      sectionsFn: () => this.helpers.getProjectsMenuSections()
    }, on: {
      backClick: this.helpers.selectProjectMenuBackClick,
      change: this.helpers.selectProjectMenuItem,
      menuChange: (ev) => this.helpers.selectMenuChanged("project", ev.detail.isOpen)
    }, class: {
      "mp-chrome-project-menu-active": isOpen.projectMenu
    } }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-project-menu-btn", attrs: {
      slot: "trigger"
    } }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-project-menu-label-container" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-project-menu-label", attrs: {
      title: this.helpers.getProjectAndWorkspaceName(
        /*truncated*/
        false
      )
    } }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-project-menu-label-project" }, this.getProjectMenuLabel()), /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-project-menu-label-workspace" }, ((_this$helpers$getCurr = this.helpers.getCurrentWorkspace()) === null || _this$helpers$getCurr === void 0 ? void 0 : _this$helpers$getCurr.name) || ""))), /* @__PURE__ */ jsx(SvgIconEl, { sel: ".mp-chrome-categories-label-filled-icon", attrs: {
      icon: "caret-down"
    } }))), displayWorkspaceSelection ? this.helpers.getUserHasCreateWorkspacePermission() ? /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-project-menu-add", attrs: {
      slot: "footer"
    } }, /* @__PURE__ */ jsx(ButtonBarEl, { attrs: {
      theme: ButtonBarTheme.Secondary
    }, on: {
      click: this.helpers.handleCreateWorkspaceBtnClick
    } }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-project-menu-button-bar-text" }, this.t("nav-header.create-data-view")))) : null : (
      // do not show add project dialog for org members unless they have perms
      /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-project-menu-add", attrs: {
        slot: "footer"
      } }, this.helpers.hasOrgs() && (!this.helpers.getOrgs()[0].id || this.helpers.getOrgsWithCreateProjectPermission().length) ? /* @__PURE__ */ jsx(ButtonBarEl, { attrs: {
        theme: ButtonBarTheme.Secondary
      }, on: {
        click: this.helpers.clickedCreateProject
      } }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-project-menu-button-bar-text" }, this.t("nav-header.create-project"))) : null)
    ));
  })());
  const getChromeCategoryItem = (href, report, categoryType, label) => {
    return /* @__PURE__ */ jsx("a", { sel: ".mp-chrome-categories-category", attrs: {
      href,
      isActiveCategory: false,
      elref: "chromeCategory".concat(categoryType)
    }, on: {
      click: () => this.helpers.handleClickReportName(report, "Top Nav")
    }, "data-sentry-component": "getChromeCategoryItem", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-categories-label-container" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-categories-label" }, label)));
  };
  const getChromeCategory = function getChromeCategory2(category) {
    let name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const isActiveCategory = category.name === selectedCategory;
    const reportsMenuOpen = category.reports && isActiveCategory;
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-categories-category", attrs: {
      elref: "chromeCategory".concat(category.name)
    }, class: {
      "mp-chrome-categories-category-active": isActiveCategory
    }, on: {
      click: () => _this.helpers.toggleSelectedCategory(category.name)
    } }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-categories-label-container" }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-categories-label" }, name || category.label), /* @__PURE__ */ jsx(SvgIconEl, { sel: ".mp-chrome-categories-label-filled-icon", attrs: {
      icon: "caret-down"
    } }), reportsMenuOpen ? /* @__PURE__ */ jsx(ReportsMenuEl, { attrs: {
      "current-report-name": currentReportName,
      "project-id": projectId,
      order: JSON.stringify(category.order || Object.keys(category.reports)),
      open: true,
      "workspace-id": workspaceId
    }, params: {
      reports: category.reports
    }, class: {
      "mp-chrome-categories-label-report-menu-new-nav": true
    }, on: {
      closemenu: () => _this.update({
        selectedCategory: ""
      })
    } }) : null))));
  };
  return /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header", class: {
    "mp-chrome-header-root": true,
    "mp-chrome-header-hidden": this.params.hidden
  }, hook: !this.params.hidden ? this.helpers.stickyElemHooks : {}, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-row-primary" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-inner" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-left" }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("a", { sel: ".mp-chrome-header-left-avatar", attrs: {
    href: this.getLeftAvatarUrl()
  }, on: {
    click: () => this.helpers.handleClickReportName(ReportName.Dashboards, "Home")
  } }, /* @__PURE__ */ jsx(OrganizationIconEl, { attrs: {
    title: "Home"
  }, "data-sentry-element": "OrganizationIconEl", "data-sentry-source-file": "template.tsx" })), projectId ? /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-categories-container" }, getChromeCategoryItem(this.getBrowseUrl({
    queryParam: {
      "entity-type-filter": BrowseEntityTypeFilter.Dashboard
    },
    resetFilters: true
  }), ReportName.Dashboards, NavCategoryType.Dashboards, this.t("mixology.app.boards")), getChromeCategory(categories ? categories["analysis"] : {
    label: NavCategoryType.Analysis,
    name: "analysis",
    reports: {}
  }, this.t("mixology.report", {
    context: "plural"
  })), getChromeCategoryItem(this.getReportUrl("users"), ReportName.Users, NavCategoryType.Users, this.t("mixology.app.users")), getChromeCategoryItem(this.getReportUrl("events"), ReportName.Events, NavCategoryType.Events, this.t("mixology.app.events"))) : null)), shouldDisplayNavigationOptions ? /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-center", attrs: {
    elref: "chromeHeaderCenter"
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-categories-container" }, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-categories-container-search" }, /* @__PURE__ */ jsx(GlobalSearchEl, { params: {
    currentUrlPath: this.state.currentUrlPath
  } })))) : null, /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-header-right" }, shouldDisplayNavigationOptions ? dataManagementMenu : null, shouldDisplayNavigationOptions && this.helpers.currentProjectStoreHasValue() && !this.helpers.hasProjectFeatureFlag(ProjectFeatureFlag.HideMenuApps) ? applicationMenu : null, helpMenu, settingsMenu, projectMenu))), errorAlertMsg && /* @__PURE__ */ jsx(ToastPortalEl, { props: {
    toast: {
      isStatic: true,
      type: "error",
      message: errorAlertMsg,
      closeToastCallback: this.helpers.handleErrorToastClosed
    }
  } }), createProjectError && /* @__PURE__ */ jsx(ToastPortalEl, { props: {
    toast: {
      isStatic: true,
      type: "error",
      message: "Failed to create new project. Error: ".concat(createProjectError)
    }
  } }), isOpen.createProjectModal && this.helpers.hasOrgs() ? /* @__PURE__ */ jsx(CreateProjectModalEl, { attrs: {
    open: true,
    orgs: this.helpers.getOrgs(),
    "organization-id": this.helpers.orgIdForCreateProject()
  }, on: {
    cancel: this.helpers.clickedCancel,
    create: this.helpers.clickedCreate
  } }) : null, isOpen.inviteModal ? /* @__PURE__ */ jsx(InviteUsersModalEl, { attrs: {
    open: true
  }, props: {
    orgs: inviteModalOrgs
  }, on: {
    save: this.helpers.closeInviteModal,
    cancel: this.helpers.closeInviteModal,
    notify: this.helpers.handleNotify,
    error: this.helpers.handleError
  } }) : null, isOpen.searchModal ? /* @__PURE__ */ jsx(LoadEntityModalEl, { attrs: _objectSpread({
    open: true,
    "modal-title": "Open Report",
    "project-id": projectId,
    "track-name": "Content Discovery",
    "search-text": searchedText,
    "user-id": (_this$getCurrentUser = this.getCurrentUser()) === null || _this$getCurrentUser === void 0 ? void 0 : _this$getCurrentUser.id,
    "workspace-id": currentWorkspace ? currentWorkspace.id : 0,
    "filter-default-open": true
  }, searchModalDisplayContext ? {
    "entity-type-filter": searchModalDisplayContext
  } : {}), on: {
    close: this.helpers.handleSearchModalClose
  } }) : null, showSupportWidget ? /* @__PURE__ */ jsx(SupportWidgetEl, { attrs: this.helpers.supportWidgetAttrs(), on: {
    closeWidget: this.helpers.closeSupportWidget
  }, props: {
    maximize: isSupportWidgetMaximized
  } }) : null, showChangelogModal ? /* @__PURE__ */ jsx(ChangelogModalEl, { onCloseHandler: () => this.helpers.handleChangelogModalClose(), productUpdates: (_this$state$productUp = this.state.productUpdates) !== null && _this$state$productUp !== void 0 ? _this$state$productUp : [] }) : null, this.helpers.showOnboardingChecklist() && /* @__PURE__ */ jsx(OnboardingChecklistEl, { params: {
    shouldCollapse: this.helpers.hasOpenModal(),
    dismissCallback: this.helpers.dismissOnboardingChecklist,
    completeCallback: this.helpers.completeOnboardingChecklist,
    inviteCallback: this.helpers.openInviteUserModal,
    viewingBoards: getReportName() === ReportName.Dashboards,
    userEmail: (_this$getCurrentUser2 = this.getCurrentUser()) === null || _this$getCurrentUser2 === void 0 ? void 0 : _this$getCurrentUser2.email
  } }));
}
